import React from 'react'
import { useTranslation } from 'react-i18next'
import { ensureHttp } from 'modules/link'
import openSmsWindow from 'sms/openSmsWindow'

import { useBusinessCard } from 'components/BusinessCard/context'
import { SocialContainer, SocialLink } from 'components/BusinessCard/components/StyledComponents'
import { PERSON_TYPE } from 'components/BusinessCard'
import { Separator, spacing } from '@PipelineDeals/shared-react-components'

const googleSearchQuery = (resource, resourceType) => {
  let query = ''

  if (resourceType === PERSON_TYPE) {
    if (resource.full_name) { query = resource.full_name }
    if (resource.company_name) { query += ` ${resource.company_name}` }
  } else {
    if (resource.name) { query = resource.name }
  }

  return query.trim()
}

const googleLink = (resource, resourceType) => {
  return `https://www.google.com/search?q=${googleSearchQuery(resource, resourceType)}`
}

const sms = (person) => {
  const { t } = useTranslation()
  return (
    <SocialLink
      title={t('businessCard.actions.sendSms')}
      onClick={(e) => {
        window.trackableEvent.sms.clickSmsIcon({ smsEnable: Boolean(window.Features.sms_support) })
        openSmsWindow({ personId: person.id })
      }}
    >
      <i className="fas fa-comment-sms" />
    </SocialLink>
  )
}

const twitter = (resource) => {
  return (
    <SocialLink
      href={resource.twitter_url}
      disabled={!resource.twitter_url}
      target="_blank"
      rel="noopener noreferrer"
      title={resource.twitter}
      onClick={(e) => !resource.twitter_url && e.preventDefault()}
    >
      <i className="fa-brands fa-square-x-twitter" />
    </SocialLink>
  )
}

const linkedIn = (resource) => {
  return (
    <SocialLink
      href={ensureHttp(resource.linked_in_url)}
      disabled={!resource.linked_in_url}
      target="_blank"
      title={resource.linked_in_url}
      rel="noopener noreferrer"
    >
      <i className="fab fa-linkedin" />
    </SocialLink>
  )
}

const facebook = (resource) => {
  return (
    <SocialLink
      href={ensureHttp(resource.facebook_url)}
      disabled={!resource.facebook_url}
      target="_blank"
      rel="noopener noreferrer"
      title={resource.facebook_url}
    >
      <i className="fab fa-facebook" />
    </SocialLink>
  )
}

const instantMessage = (resource) => {
  return (
    <SocialLink
      href="#"
      disabled={!resource.instant_message}
      title={resource.instant_message}
    >
      <i className="far fa-comments" />
    </SocialLink>
  )
}

const renderGoogleSearchQuery = (resource, resourceType) => {
  const { t } = useTranslation()
  return (
    <SocialLink
      href={googleLink(resource, resourceType)}
      disabled={!googleSearchQuery(resource, resourceType).length}
      target="_blank"
      rel="noopener noreferrer"
      title={t('businessCard.actions.googleSearch')}
    >
      <i className="fab fa-google" />
    </SocialLink>
  )
}

const SocialSection = () => {
  const { cardMeta: { showOnlyFields }, resource, resourceType } = useBusinessCard()

  const isPerson = resourceType === PERSON_TYPE
  const showSocial = showOnlyFields.includes('twitter') || showOnlyFields.includes('linked_in_url') || showOnlyFields.includes('facebook_url') || showOnlyFields.includes('instant_message')

  if (!showSocial) return null

  return (
    <div>
      <Separator width="100%" marginTop="0px" marginBottom={spacing.xl} />
      <SocialContainer>
        {isPerson && sms(resource)}
        {twitter(resource)}
        {linkedIn(resource)}
        {facebook(resource)}
        {instantMessage(resource)}
        {renderGoogleSearchQuery(resource, resourceType)}
      </SocialContainer>
    </div>
  )
}

export default SocialSection
